<ch-loader [loading]="loading"></ch-loader>

<div class="top" [ngStyle]="{ display: loading ? 'none' : 'block' }">
  <ch-breadcrumb *ngIf="!hasOffer" [parts]="['Send Notifications']"></ch-breadcrumb>
  <ch-breadcrumb *ngIf="hasOffer" [parts]="[offerLabel()]"></ch-breadcrumb>
  <form #form="ngForm" (ngSubmit)="send(form)">
    <div class="container-fluid">
      <div class="row">
        <div class="col-sm-9 col-md-9 pr-5">
          <div class="card mb-9">
            <div class="card-header">Notification</div>
            <div class="card-body">
              <div class="form-group">
                <ch-live-search
                  id="cities-selector"
                  [nothingSelectedText]="nothingSelectedMessage"
                  [resetOnSelect]="true"
                  [items]="cities"
                  [showClass]="1"
                  (change)="locationAdded($event)"
                ></ch-live-search>
              </div>

              <div class="selected-locations-list form-group">
                <span *ngFor="let city of selectedCities()" class="type-item">
                  {{ city.value }} <i class="fa fa-close type-item" (click)="removeCity(city.id)"></i>
                </span>
              </div>

              <div class="form-group">
                <label for="message-title">Title</label>
                <input
                  type="text"
                  class="form-control"
                  [(ngModel)]="message.title"
                  name="title"
                  #title="ngModel"
                  class="form-control"
                  id="message-title"
                  required
                  [readonly]="loading"
                />
                <small class="text-danger" *ngIf="(title.touched || title.dirty) && !title.valid"> The notification needs a title. </small>
              </div>

              <div class="form-group">
                <label for="notification-body">Notification Body</label>
                <input
                  id="notification-body"
                  [(ngModel)]="message.body"
                  name="body"
                  #body="ngModel"
                  class="form-control"
                  required
                  [readOnly]="loading"
                />
                <small class="text-danger" *ngIf="(body.touched || body.dirty) && !body.valid">
                  The notification's body is required.
                </small>
              </div>

              <div style="margin-top: 40px;">
                <span class="btn-right">
                  <span *ngIf="sending">
                    <div style="width: 34px; height: 34px;" class="loading-spinner"></div>
                  </span>
                  <button id='senderSend' *ngIf="!sending" type="submit" class="btn btn-primary" [disabled]="loading">Send</button>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>



// WEBPACK FOOTER //
// /Users/thxgg/Projects/Work/code-hospitality-cms/src/app/notifications/sender/sender.component.html